import { render, staticRenderFns } from "./video-background.vue?vue&type=template&id=6bb34f54&scoped=true&"
import script from "./video-background.vue?vue&type=script&lang=js&"
export * from "./video-background.vue?vue&type=script&lang=js&"
import style0 from "./video-background.vue?vue&type=style&index=0&id=6bb34f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb34f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6bb34f54', component.options)
    } else {
      api.reload('6bb34f54', component.options)
    }
    module.hot.accept("./video-background.vue?vue&type=template&id=6bb34f54&scoped=true&", function () {
      api.rerender('6bb34f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/video-background.vue"
export default component.exports